module.exports = __webpack_public_path__ + "img/查看.8bc61760.svg";